import { render, staticRenderFns } from "./queryBtnsDT.vue?vue&type=template&id=55d4383c&"
import script from "./queryBtnsDT.vue?vue&type=script&lang=js&"
export * from "./queryBtnsDT.vue?vue&type=script&lang=js&"
import style0 from "./queryBtnsDT.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports